import React from "react";
import classes from "./availabilitySelections.module.scss";
import classes2 from "../SpecialEvents/specialeventsdetail.module.scss"
import { useSelector } from "react-redux";

const TimeOffPTOLinkComp = (props) => {
  const urlDetails = useSelector((state) => state.url.urlData);
  const ptoQuickRefLinkAVL = urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_AVL_QRC;//REACT_APP_WFM_AVAILABILITY_AVL_TIMEOFF;
  const ptoQuickRefLinkSEA =urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_SEA_QRC; //REACT_APP_WFM_AVAILABILITY_SEA_TIMEOFF;
  const ptoLink = urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_PTO_URL;

  let quickRefLink = props.type == "AVL" ? ptoQuickRefLinkAVL: ptoQuickRefLinkSEA; 
  console.log("PTO Quick Ref Link"+ quickRefLink);
  console.log("Time Off Link"+ ptoLink);
  console.log("URl Redux State"+ JSON.stringify(urlDetails));

    return(
        <div className={classes.page_quicklinks_wrap}>
          
          {!props.isMobile && props.type!=="AVL" ? <a className="link" href={ptoLink} target="_blank">
            <div className={classes2.page_quicklink}>
              <u>Visit My Time Off</u>
            </div>
          </a>: <a className="link" href={ptoLink} target="_blank">
            <div className={classes.page_quicklink}>
              <u>Visit My Time Off</u>
            </div>
          </a> }
          {!props.isMobile && props.type!=="AVL" ?
          <a className="link" href={quickRefLink} target="_blank">
            <div className={classes2.page_quicklink2}>
              <u>Quick Reference Card</u>
            </div>
          </a>:  <a className="link" href={quickRefLink} target="_blank">
            <div className={classes.page_quicklink}>
              <u>Quick Reference Card</u>
            </div>
          </a>}
        </div>

    );
}

export const ComponentType = {
  AVL: 'AVL',
  SEA: 'SEA',
}

export default TimeOffPTOLinkComp;
